import React, { useState, useContext } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import { AuthContext } from "../Contexts/AuthContext";

export default function NavBar(props) {
  const [nav, setNav] = useState(false);
  const { auth } = useContext(AuthContext);
  const history = useHistory();
  const location = useLocation();

  let handleNav = () => {
    if (nav) {
      setNav((val) => !val);
    }
  };
  return (
    <nav className={nav ? "posFixed" : ""}>
      <div className="navContainer" id="navContainer">
        <div className="logoContainer">
          <Link to="/" style={{ display: "flex", alignItems: "center" }}>
            <img
              className="logo"
              src={require("../Assets/logo.svg")}
              alt="Asyncus"
            />
            <h1>Asyncus</h1>
          </Link>
        </div>
        <div className="ulContainer">
          <ul className={nav ? "visibleFlex" : ""}>
            <li onClick={handleNav}>
              <Link
                to="/"
                className={location.pathname === "/" ? "selectedLink" : ""}
              >
                Home
              </Link>
            </li>
            <li onClick={handleNav}>
              <Link
                to="/services"
                className={
                  location.pathname === "/services" ? "selectedLink" : ""
                }
              >
                Services
              </Link>
            </li>
            {/* <li onClick={handleNav}>
              <Link
                to="/works"
                className={location.pathname === "/works" ? "selectedLink" : ""}
              >
                Our Works
              </Link>
            </li> */}
            <li onClick={handleNav}>
              <Link
                to="/contact"
                className={
                  location.pathname === "/contact" ? "selectedLink" : ""
                }
              >
                Contact
              </Link>
            </li>
            <li>
              {auth ? (
                <img
                  className="navPic"
                  src={JSON.parse(auth).photo}
                  alt=""
                  onClick={() => {
                    handleNav();
                    history.push("/profile");
                  }}
                />
              ) : (
                <button
                  style={{ width: "100px" }}
                  onClick={() => props.setShowForm((val) => !val)}
                >
                  Login
                </button>
              )}
            </li>
          </ul>
          <img
            className="hamburger"
            src={
              !nav
                ? require("../Assets/menu.svg")
                : require("../Assets/close.svg")
            }
            alt="Menu"
            onClick={() => setNav((nav) => !nav)}
          />
        </div>
      </div>
    </nav>
  );
}
